import HomeScene from "./scenes/HomeScene";
import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router-dom";
import ExploreWines from "./scenes/ExploreWines";
import { initializeApp } from "firebase/app";
import { getFirestore, addDoc, collection } from "@firebase/firestore";
import { getAnalytics, logEvent } from "firebase/analytics";
import "./App.css";
import PenfoldsHistory from "./scenes/PenfoldsHistory";
import TasteOfMirazur from "./scenes/TasteOfMirazur";
import TastingNotes from "./scenes/TastingNotes";
import WineDetail from "./scenes/WineDetail";
import React, { useCallback, useEffect } from "react";
import { allLinks } from "./scenes/ThreedScene/ThreedScene";
import BrandExperience from "./scenes/BrandExperience/BrandExperience";
import ShowAllOrders from "./scenes/ShowAllOrders/ShowAllOrders";
import { NotificationPopup } from "./components/popup";

const firebaseConfig = {
  apiKey: "AIzaSyCYis8bwUv4C5CW33LrSSoxb-W8pksdIuY",
  authDomain: "penfold-e4a29.firebaseapp.com",
  projectId: "penfold-e4a29",
  storageBucket: "penfold-e4a29.appspot.com",
  messagingSenderId: "234512627808",
  appId: "1:234512627808:web:ec39d67e335733c08b6b05",
  measurementId: "G-XL41HHPGNH",
};

export const addGAWithUserInfo = (eventName, data = {}) => {
  const analytics = getAnalytics();
  try {
    let baseData = {
      dateTimeStamp: new Date().getTime(),
    };
    let wholeData = { ...baseData, ...data };
    // console.log(eventName, data);
    logEvent(analytics, eventName, wholeData);
  } catch (error) {
    console.error(error);
  }
};

// const wineObj = {
//   alcoholContent: 14.5,
//   awards: `"Evenly balanced wine with cassis, mulberry black cherry fruits, and roasted chestnutcedar wood notes. Quite muscular in attack but has the density and the richness to carry the tannins.” – Andrew Caillard MW`,
//   images: [
//     "https://storage.googleapis.com/penfold-e4a29.appspot.com/Penfolds_Max%20Chardonnay_001_Product.jpg",
//     "https://storage.googleapis.com/penfold-e4a29.appspot.com/Penfolds_Max%20Chardonnay_004_Product.jpg",
//     "https://storage.googleapis.com/penfold-e4a29.appspot.com/Penfolds_Max%20Chardonnay_005_Product.jpg",
//   ],
//   imgUrl:
//     "https://firebasestorage.googleapis.com/v0/b/penfoldsdj.appspot.com/o/wine6.png?alt=media&token=8955083b-d00e-4e63-b808-fc24fa0364a7",
//   info: "Often referred to as the 'Baby Grange', Bin 389 is one of the best examples of the Cabernet Shiraz blend that Australia is famous for. Sourced from the finest fruit-growing regions, this flagship wine is a wonderful union of Cabernet and Shiraz. Bold and intense, the nose is an explosion of fruits, cola, grated chocolate, juniper, sage/rosemary spices. The palate is fleshy, savoury and salivating, packed with liquorice, stewed plum, blackcurrant fruits, dark chocolate and mocha.",
//   name: "PENFOLDS BIN 389 CABERNET SHIRAZ VINTAGE 2019",
//   pairing:
//     "It pairs with rich, red meat dishes like beef short ribs and lamb rack.",
//   retail: "3499",
//   size: "75 ml",
//   serveNstore: "",
//   type: ["VENTURE BEYOND"],
// };
function App() {
  const app = initializeApp(firebaseConfig);
  const db = getFirestore(app);

  // const addData = useCallback(async () => {
  //   try {
  //     await addDoc(collection(db, "wines"), wineObj);
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }, [db]);

  // useEffect(() => {
  //   addData();
  // }, [addData]);

  return (
    <>
      <BrowserRouter>
        <Routes>
          {Object.keys(allLinks).map((key, index) => (
            <Route
              key={index}
              path={allLinks[key].route}
              element={<HomeScene db={db} />}
            />
          ))}
          <Route
            path="/brand-experience"
            element={<BrandExperience db={db} />}
          />
          <Route path="/explore" element={<ExploreWines db={db} />} />
          <Route path="/history" element={<PenfoldsHistory db={db} />} />
          <Route path="/taste" element={<TasteOfMirazur db={db} />} />
          <Route path="/notes" element={<TastingNotes db={db} />} />
          <Route path="/detail" element={<WineDetail db={db} />} />
          <Route path="/allorders" element={<ShowAllOrders db={db} />} />
          <Route path="/categories/:id" />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;

// "site":"mainsite1",z
